module.exports = __webpack_public_path__ + "img/foto-s-zanatiy-3.b4f4aebf.png";